import * as globals from '@wandb/weave/common/css/globals.styles';
import {useBooleanState} from '@wandb/weave/common/util/hooks';
import {IconMegaphone} from '@wandb/weave/components/Icon';
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React, {type FC, useContext} from 'react';
import styled from 'styled-components';

import {trackNavRightFeatureOpened} from '../../../services/analytics/productEvents';
import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {
  openBeamer,
  useBeamerAvailable,
  useBeamerHasNewPosts,
} from '../../../util/beamer';
import {AccountSelectorContext} from './AccountSelectorContextProvider';
import {Button, Wrapper} from './NavResources';

const NavWhatsNewButton: FC = () => {
  const {
    state: tooltipOpen,
    setTrue: openTooltip,
    setFalse: closeTooltip,
  } = useBooleanState(false);

  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';
  const hasNewPosts = useBeamerHasNewPosts();
  const beamerAvailable = useBeamerAvailable();
  const {selectedAccount} = useContext(AccountSelectorContext);

  const handleClick = () => {
    trackNavRightFeatureOpened({
      feature: 'whats_new',
      selected_account: selectedAccount,
      is_admin_mode: isAdminMode,
    });
    openBeamer();
  };

  if (beamerAvailable !== true) {
    return null;
  }

  return (
    <Wrapper $marginRight={7}>
      <TooltipDeprecated
        position="bottom center"
        open={tooltipOpen}
        onOpen={openTooltip}
        onClose={closeTooltip}
        trigger={
          <Button
            $active={false}
            $showAdminBanner={isAdminMode}
            aria-label="What's new"
            onClick={handleClick}>
            <Icon />
            {hasNewPosts && <AlertPill $showAdminBanner={isAdminMode} />}
          </Button>
        }>
        What's new
      </TooltipDeprecated>
    </Wrapper>
  );
};

export default NavWhatsNewButton;

const Icon = styled(IconMegaphone)`
  display: block;
  width: 24px;
  height: 24px;
`;
Icon.displayName = 'S.Icon';

const AlertPill = styled.div<{$showAdminBanner?: boolean}>`
  width: 14px;
  height: 14px;
  background-color: ${globals.RED_500};
  border-radius: 50%;
  border: ${props =>
    props.$showAdminBanner
      ? `2px solid ${globals.GOLD_550}`
      : `2px solid ${globals.MOON_950}`};
  position: absolute;
  top: -1px;
  right: -1px;
`;
AlertPill.displayName = 'S.AlertPill';
